module.exports = __webpack_public_path__ + "static/media/testimonial-img.0a6da5e3.jpg";